import * as _ from 'lodash';
import { Action, createReducer, on } from '@ngrx/store';
import * as ActivityActions from './activity.actions';

export interface State {
  entities: any[]
}

export const initialState: State = {
  entities: []
};

let index = 0;
export const activityReducer = createReducer(
  initialState,

  on(ActivityActions.updateVirtualEventActivity, (state: any, action) => {
    const entities = _.chain([
      {...action.payload, index: index++ },
      ...state.entities,
    ]).take(100).value();
    return { ...state, entities };
  }),

  on(ActivityActions.clearVirtualEventActivity, (state) => {
    return {
      entities: []
    };
  })

);

export function reducer(state, action) {
  return activityReducer(state, action);
}